import Table, { ColumnsType } from "antd/lib/table"
import { parseTypeEntryName } from "../../../../domain/entity/financial-entry.entity"
import { useDateTimeUtil } from "../../../../core/util/date-time.util";
import { useNumberFormatter } from "../../../service/number-formatter.service";
import { Button, Col, Divider, Form, Row, Space } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useFinancialEntryRepository } from "../../../../domain/repository/financial-entry.repository";
import { DatePickerPtBr } from "../../../../core/component/date-picker-ptbr";
import { ExportOutlined, SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import { AppPageHeader } from "../../../../core/component/page-header";

export function ReportEntriesWithApportionment(props: any) {
  const [form] = Form.useForm();
  const [data, setData]  = useState<any[]>([]);
  const [startDate, setStartDate] = useState(new Date(2025,1,1));
  const [endDate, setEndDate] = useState(new Date());
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  
  const { decimalFormatter } = useNumberFormatter();
  const dateTimeUtil = useDateTimeUtil();
  const entryRepo = useFinancialEntryRepository();

  const loadData = useCallback((startDate: Date, endDate: Date, limit: number, offset: number) => {
    return entryRepo.listEntriesWithapportionment({
      startDate,
      endDate,
      limit,
      offset,
    }).then(res => {
      setData(res.data)
      setTotal(res.total ?? 0)
    })
  }, [])

  useEffect(() => {
    const offset = (page - 1) * limit;
    loadData(startDate, endDate, limit, offset)
  }, [loadData, startDate, endDate, limit, page])

  const columns: ColumnsType<any> = [
    {
      title: 'Número Lançamento',
      dataIndex: 'entryId',
      key: 'id'
    },
    {
      title: 'Filial',
      dataIndex: 'firm',
    },
    {
      title: 'Cli/For',
      dataIndex: 'person',
    },
    {
      title: 'Data de Entrada',
      dataIndex: 'dateTimeEntry',
      render: dateTimeUtil.convertToDatePtBr,
    },
    {
      title: 'Valor Bruto',
      dataIndex: 'documentGrossValue',
      render: decimalFormatter.format,
    },
    {
      title: 'Centro de Custo',
      dataIndex: 'costCenter',
    },
    {
      title: 'Rateio',
      render: (_, row) => `${decimalFormatter.format(row['apportionment'])} (${row['percent']}%)`
    },
    // {
    //   title: '',
    //   key: 'action',
    //   dataIndex: 'entryId',
    //   render: (id) => (
    //     <Button
    //       type={'ghost'}
    //       shape={'round'}
    //       size={'small'}
    //       onClick={() => null}
    //     >
    //       Detalhes
    //     </Button>
    //   )
    // }
  ]

  const onExport = useCallback(() => {
    return entryRepo.listEntriesWithapportionment({
      endDate,
      startDate,
      limit: total,
      offset: 0,
      export: true
    })
  }, [startDate, endDate, total])

  const onFilter = useCallback((values: any) => {
    const { startDate, endDate } = values;
    setStartDate(startDate.toDate());
    setEndDate(endDate.toDate());
    setPage(1);
  
  }, [])

  return (
    <>
      <AppPageHeader
          title={'Relatório de Lançamentos com Rateio'}
          mode={props.mode}
          subtitle={'Pesquise por data de entrada'}
      />
      <Divider />
      <Form
        form={form}
        onFinish={onFilter}
        layout={'horizontal'}
        size={'middle'}
        initialValues={{ endDate: moment(endDate), startDate: moment(startDate) }}
      >
        <Row gutter={12}>
          
          <Col span={4}>
            <DatePickerPtBr
              label={''}
              name={'startDate'}
              required={true}
              placeholder={'Data de Entrada Incial'}
            />
          </Col>
          <Col span={4}>
            <DatePickerPtBr
              label={''}
              name={'endDate'}
              required={true}
              placeholder={'Data de Entrada Final'}
            />
          </Col>
          <Col>
            <Space align={'center'} >
              <Button icon={<SearchOutlined />} shape={'round'} htmlType={'submit'}>
                Filtrar
              </Button>
              <Button
                icon={<ExportOutlined />}
                shape={'round'}
                htmlType={'button'}
                onClick={() => onExport()}
              >
                Exportar
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
      <Table 
        loading={entryRepo.loading}
        columns={columns}
        dataSource={data}
        pagination={{
          onChange: setPage,
          defaultPageSize: limit,
          onShowSizeChange: (current, size) => {
            setLimit(size)
          },
          current: page,
          total,
        }}
      />
    </>
  )

}